import * as React from 'react';
import { Button,Icon } from '@alifd/next';
import CallUsBtn from './call-us';
import ContactSupplier from './contact-supplier';
import ChatNow from './chat-now';
import './index.scss';


export default function Inquery ( props: { i18n: any; hasVideoChat: any; children: any; } ) {
    const { i18n,hasVideoChat,children } = props;

    return <>
        <div className="main-actions inquery">
            <div className="action-info">{i18n['supplierCard.action.tip']}</div>
            <div className="action-item">
                <ContactSupplier {...props as any}>
                  <Button type="primary">
                      <Icon type="email" />{i18n['mainAction_operate_contact']}
                  </Button>
                </ContactSupplier>
            </div>
            {hasVideoChat && <div className="action-item">
              <CallUsBtn {...props as any}/>
              </div>}
            <ChatNow {...props}/>
        </div>
    </>
}
